import { UiSocialShareModel } from "../../models";

export function mockUiSocialShareModel({
    id = "SocialShare-1234",
    type = "uiSocialShare",
    locale = "en",
    content = mockUiSocialShareModelContent()
}: Partial<UiSocialShareModel> = {}): UiSocialShareModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiSocialShareModelContent = UiSocialShareModel["content"];

export function mockUiSocialShareModelContent({
    text = "Lorem Ipsum",
    twitterButtonText = "Tweet",
    facebookButtonText = "Share",
    ...optionals
}: Partial<UiSocialShareModelContent> = {}): UiSocialShareModelContent {
    return {
        text,
        twitterButtonText,
        facebookButtonText,
        ...optionals
    };
}
